import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import EditorControls from './EditorControls';
import ImageEditor from '../../../blocks/ImageEditor';
import ProfileImage from '../../../elements/ProfileImage';
import Button from '../../../elements/Button';

class ViewImage extends React.PureComponent {
  fileInputRef = React.createRef();

  _choosePhotoHandler = (e) => {
    e.preventDefault();
    this.fileInputRef.current.click();
  };

  render() {
    const { _handlePhotoChange, imgSrc } = this.props;

    return (
      <ImageEditor>
        <ImageEditor.Image>
          <ProfileImage src={imgSrc} />
        </ImageEditor.Image>
        <EditorControls>
          <input hidden onChange={_handlePhotoChange} ref={this.fileInputRef} type="file" />
          <Button modifiers={['primary', 'small']} onClick={this._choosePhotoHandler}>
            <FormattedMessage
              id="ViewImage.choosePhotoBtn"
              defaultMessage="Choose Photo"
            />
          </Button>
        </EditorControls>
      </ImageEditor>
    );
  }
}

ViewImage.propTypes = {
  _handlePhotoChange: PropTypes.func.isRequired,
  imgSrc: PropTypes.string.isRequired,
};

export default ViewImage;
